export const SET_COACH = '[COACHES] SET_COACH';
export const SET_IS_FETCHING_COACH = '[COACHES] SET_IS_FETCHING_COACH';

export const SET_COACHES = '[COACHES] SET_COACHES';
export const SET_IS_FETCHING_COACHES = '[COACHES] SET_IS_FETCHING_COACHES';
